module.exports = __webpack_public_path__ + "static/media/14.104.27e3620a.webp";